var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningConstruction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508 508",
    style: {
      enableBackground: "new 0 0 508 508"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 254,
    cy: 254,
    r: 254
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M369.6,210.4c-1.6,0-2.8-1.2-2.8-2.8V192c0-2.8-1.6-5.2-4-6.8c-4-2.8-6.4-7.2-6-12.4 c0.8-6,5.6-10.8,11.2-11.2c3.6-0.4,7.2,0.8,10,3.2s4.4,6,4.4,9.6c0,1.6-1.2,2.8-2.8,2.8c-1.6,0-2.8-1.2-2.8-2.8c0-2-0.8-4-2.4-5.2 s-3.6-2-5.6-1.6c-3.2,0.4-5.6,2.8-6,6c-0.4,2.8,0.8,5.2,3.2,6.8c4,2.8,6.8,7.2,6.8,11.6v15.6C372.8,209.2,371.2,210.4,369.6,210.4z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M138.4,210.4c-1.6,0-2.8-1.2-2.8-2.8V192c0-4.8,2.4-9.2,6.8-11.6c2.4-1.6,3.6-4,3.2-6.8 c-0.4-3.2-2.8-5.6-6-6c-2-0.4-4,0.4-5.6,1.6c-1.6,1.2-2.4,3.2-2.4,5.2c0,1.6-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8 c0-3.6,1.6-7.2,4.4-9.6c2.8-2.4,6.4-3.6,10-3.2c6,0.8,10.8,5.6,11.2,11.2c0.4,4.8-1.6,9.6-6,12.4c-2.4,1.6-4,4-4,6.8v15.6 C141.2,209.2,140,210.4,138.4,210.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M420.8,386.4H87.2c-1.6,0-3.2-1.6-3.2-3.2V188.8c0-1.6,1.6-3.2,3.2-3.2h334c1.6,0,3.2,1.6,3.2,3.2 v194.4C424.4,384.8,422.8,386.4,420.8,386.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CED5E0"
    },
    d: "M364.4,173.6c-0.8,0-1.6-0.4-2-0.8L254,101.6l-108.4,71.2c-2,1.2-4.4,0.8-5.6-1.2 c-1.2-2-0.8-4.4,1.2-5.6l110.4-72.8c1.2-0.8,3.2-0.8,4.4,0L366.4,166c2,1.2,2.4,3.6,1.2,5.6C366.8,172.8,365.6,173.6,364.4,173.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 254,
    cy: 98,
    r: 30
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF7058"
    },
    cx: 254,
    cy: 98,
    r: 16.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M165.6,276c1.6,1.6,3.2,2.8,5.6,2.8c2.4,0,4.4-0.8,5.6-2.8c1.6-1.6,2-4.4,2-7.2v-21.2h8.4v21.6 c0,5.6-1.6,10-4.8,12.8s-7.2,4.4-12,4.4s-8.8-1.6-12-4.4c-3.2-3.2-4.8-7.2-4.8-12.8v-21.6h8.4v21.2C163.2,271.6,164,274,165.6,276z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M223.6,247.2h8.4v38.4h-8.4l-18.4-24v24h-8.4v-38.4h8l18.8,24.8L223.6,247.2L223.6,247.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M270.8,252.4c3.6,3.2,5.6,8,5.6,14s-1.6,10.8-5.2,14c-3.6,3.6-9.2,5.2-16.4,5.2h-13.2v-38.4h13.6 C262,247.2,267.2,249.2,270.8,252.4z M264.4,275.2c2-2,3.2-4.8,3.2-8.8c0-3.6-1.2-6.8-3.2-8.8s-5.2-3.2-9.6-3.2H250V278h5.6 C259.2,278,262.4,277.2,264.4,275.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M311.6,247.2v7.6h-19.2v8h17.2v7.2h-17.2v8H312v7.6h-28.4v-38.4L311.6,247.2L311.6,247.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M350.8,260c0,6-2.4,10-7.2,12l9.6,13.6h-10.4l-8.8-12h-6V286h-8.4v-38.4H334c6,0,10.4,1.2,12.8,3.2 C349.6,252.4,350.8,255.6,350.8,260z M340.4,264.8c1.2-0.8,1.6-2.4,1.6-4.4s-0.4-3.6-1.6-4.4s-3.2-1.2-5.6-1.2h-6.4V266h6.4 C337.6,266,339.6,265.6,340.4,264.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M128.4,319.6c2.4,0,4.8-1.2,6.4-3.2l3.2,3.6c-2.8,2.8-5.6,4.4-9.2,4.4c-3.6,0-6.4-1.2-8.8-3.2 c-2.4-2.4-3.6-5.2-3.6-8.4c0-3.6,1.2-6.4,3.6-8.8s5.2-3.6,8.8-3.6c4,0,7.2,1.6,9.6,4.4l-3.2,3.6c-1.6-2-3.6-3.2-6-3.2 c-2,0-3.6,0.8-5.2,2c-1.2,1.2-2,2.8-2,5.2s0.8,4,2,5.2C125.2,318.8,126.8,319.6,128.4,319.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M161.2,321.2c-2.4,2.4-5.2,3.6-8.8,3.6s-6.4-1.2-8.8-3.6c-2.4-2.4-3.6-5.2-3.6-8.4 c0-3.6,1.2-6.4,3.6-8.4c2.4-2.4,5.2-3.6,8.8-3.6s6.4,1.2,8.8,3.6c2.4,2.4,3.6,5.2,3.6,8.4S163.6,318.8,161.2,321.2z M159.6,312.4 c0-2-0.8-4-2-5.2c-1.2-1.6-2.8-2-4.8-2s-3.6,0.8-4.8,2c-1.2,1.6-2,3.2-2,5.2s0.8,4,2,5.2c1.2,1.6,2.8,2,4.8,2s3.6-0.8,4.8-2 S159.6,314.4,159.6,312.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M185.6,300.8h5.2V324h-5.2l-11.2-14.4V324h-5.2v-23.2h4.8l11.6,14.8V300.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M202,305.6c-0.4,0.4-0.8,0.8-0.8,1.6c0,0.8,0.4,1.2,0.8,1.6c0.8,0.4,2,0.8,4.4,1.6 c2.4,0.4,4,1.2,5.2,2.4c1.2,1.2,2,2.8,2,4.8s-0.8,3.6-2.4,5.2c-1.6,1.2-3.6,2-6,2c-3.6,0-7.2-1.2-10-4l3.2-3.6 c2.4,2,4.8,3.2,6.8,3.2c0.8,0,1.6-0.4,2.4-0.8c0.4-0.4,0.8-0.8,0.8-1.6c0-0.8-0.4-1.2-0.8-1.6c-0.4-0.4-1.6-0.8-3.6-1.2 c-2.8-0.8-4.8-1.6-6-2.4c-1.2-1.2-2-2.8-2-4.8c0-2.4,0.8-4,2.4-5.2c1.6-1.2,3.6-1.6,6-1.6c1.6,0,3.2,0.4,4.8,0.8s2.8,1.2,4,2.4 l-2.8,3.6c-2-1.6-4-2.4-6.4-2.4C203.2,304.8,202.4,305.2,202,305.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M227.2,305.6v18.8H222v-18.8h-6.4v-4.4H234v4.4H227.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M256.8,308.8c0,3.6-1.6,6-4.4,7.2l6,8.4H252l-5.2-7.6h-3.6v7.6H238v-23.2h8.8c3.6,0,6,0.8,7.6,2 C256,304,256.8,306,256.8,308.8z M250.4,311.6c0.8-0.4,0.8-1.6,0.8-2.8c0-1.2-0.4-2-0.8-2.4c-0.8-0.4-2-0.8-3.6-0.8h-4v6.8h3.6 C248.4,312.4,249.6,312,250.4,311.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M268,318.4c0.8,1.2,2,1.6,3.6,1.6s2.8-0.4,3.6-1.6c0.8-1.2,1.2-2.4,1.2-4.4v-12.8h5.2V314 c0,3.2-0.8,6-2.8,7.6c-2,2-4.4,2.8-7.2,2.8c-2.8,0-5.2-0.8-7.2-2.8s-2.8-4.4-2.8-7.6v-13.2h5.2V314 C266.8,315.6,267.2,317.2,268,318.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M297.6,319.6c2.4,0,4.8-1.2,6.4-3.2l3.2,3.6c-2.8,2.8-5.6,4.4-9.2,4.4s-6.4-1.2-8.8-3.2 c-2.4-2.4-3.6-5.2-3.6-8.4c0-3.6,1.2-6.4,3.6-8.8s5.2-3.6,8.8-3.6c4,0,7.2,1.6,9.6,4.4l-3.2,3.6c-1.6-2-3.6-3.2-6-3.2 c-2,0-3.6,0.8-5.2,2c-1.2,1.2-2,2.8-2,5.2s0.8,4,2,5.2C294.4,318.8,295.6,319.6,297.6,319.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M321.2,305.6v18.8H316v-18.8h-6.4v-4.4H328v4.4H321.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M331.6,300.8h5.2V324h-5.2V300.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M362,321.2c-2.4,2.4-5.2,3.6-8.8,3.6c-3.6,0-6.4-1.2-8.8-3.6s-3.6-5.2-3.6-8.4 c0-3.6,1.2-6.4,3.6-8.4c2.4-2.4,5.2-3.6,8.8-3.6c3.6,0,6.4,1.2,8.8,3.6s3.6,5.2,3.6,8.4S364.4,318.8,362,321.2z M360.4,312.4 c0-2-0.8-4-2-5.2c-1.2-1.6-2.8-2-4.8-2s-3.6,0.8-4.8,2c-1.2,1.6-2,3.2-2,5.2s0.8,4,2,5.2c1.2,1.6,2.8,2,4.8,2s3.6-0.8,4.8-2 C359.6,316.4,360.4,314.4,360.4,312.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M386.4,300.8h5.2V324h-5.2l-11.2-14.4V324H370v-23.2h4.8l11.6,14.8V300.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningConstruction);
export default __webpack_public_path__ + "static/media/warning-construction.b78610b0.svg";
export { ForwardRef as ReactComponent };